import apisauce from 'apisauce'
import { _captchaToken, _captchaType } from 'constants/recaptcha'

const convertToFormData = body => {
  const formDataBody = new FormData()
  Object.keys(body).forEach(key => {
    formDataBody.append(key, body[key])
  })
  return formDataBody
}

const api = apisauce.create({
  baseURL: process.env.GATSBY_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 15 * 1000,
})

export const sendSmsToPhone = data =>
  api.post('/social/invitations/join-flip-sms/v1', data)

export const contact = data => api.post('api/contact', data)

export const contactBrand = (data, headers) => {
  if (headers) {
    api.setHeaders(headers)
  } else {
    api.deleteHeader(_captchaToken)
    api.deleteHeader(_captchaType)
  }

  return api.post('shop/contact/start-selling-on-flip/v3', data)
}

export const contactAmbassador = data =>
  api.post('shop/contact/join-ambassador-program-on-flip/v1', data)

export const applyToOffer = data =>
  api.post('api/v2/contact/career', convertToFormData(data), {
    headers: { 'Content-Type': 'multipart/form-data' },
  })

export const checkUsername = data => api.put('/api/username', data)
